export default __webpack_public_path__ + "static/media/VINITA DEBYANI MISHRA.68a1e473.jpeg";